var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "execution" },
    [
      _c(
        "basic-container",
        [
          _c("avue-crud", {
            ref: "crud",
            attrs: {
              data: _vm.tableData,
              option: _vm.tableOption,
              page: _vm.page,
              permission: _vm.permissionList,
              "table-loading": _vm.tableLoading,
            },
            on: {
              "update:page": function ($event) {
                _vm.page = $event
              },
              "on-load": _vm.getList,
              "refresh-change": _vm.refreshChange,
              "search-change": _vm.searchChange,
              "size-change": _vm.sizeChange,
              "current-change": _vm.currentChange,
              "row-save": _vm.handleSave,
              "row-del": _vm.rowDel,
            },
            scopedSlots: _vm._u([
              {
                key: "appName",
                fn: function (scope) {
                  return [
                    _c("el-tag", { attrs: { size: "mini", type: "success" } }, [
                      _vm._v(_vm._s(scope.row.appName)),
                    ]),
                  ]
                },
              },
              {
                key: "nickName",
                fn: function (scope) {
                  return [
                    _c(
                      "el-badge",
                      {
                        staticClass: "count-msg",
                        attrs: { value: scope.row.countMsg },
                      },
                      [
                        _c("img", {
                          staticClass: "head-img",
                          attrs: { src: scope.row.headimgUrl },
                        }),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "readFlag",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type:
                            scope.row.readFlag == "1" ? "success" : "danger",
                          size: "mini",
                        },
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(scope.row.$readFlag) +
                            "\n\t\t\t\t"
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "repContent",
                fn: function (scope) {
                  return [
                    _c("div", { staticClass: "nick-name" }, [
                      _vm._v(_vm._s(scope.row.nickName)),
                    ]),
                    scope.row.repType == "event" &&
                    scope.row.repEvent == "subscribe"
                      ? _c(
                          "div",
                          [
                            _c(
                              "el-tag",
                              { attrs: { size: "mini", type: "success" } },
                              [_vm._v("关注")]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    scope.row.repType == "event" &&
                    scope.row.repEvent == "unsubscribe"
                      ? _c(
                          "div",
                          [
                            _c(
                              "el-tag",
                              { attrs: { size: "mini", type: "danger" } },
                              [_vm._v("取消关注")]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    scope.row.repType == "event" &&
                    scope.row.repEvent == "CLICK"
                      ? _c(
                          "div",
                          [
                            _c("el-tag", { attrs: { size: "mini" } }, [
                              _vm._v("点击菜单"),
                            ]),
                            _vm._v(
                              "\n\t\t\t\t\t：【" +
                                _vm._s(scope.row.repName) +
                                "】\n\t\t\t\t"
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    scope.row.repType == "event" && scope.row.repEvent == "VIEW"
                      ? _c(
                          "div",
                          [
                            _c("el-tag", { attrs: { size: "mini" } }, [
                              _vm._v("点击菜单链接"),
                            ]),
                            _vm._v(
                              "\n\t\t\t\t\t：【" +
                                _vm._s(scope.row.repUrl) +
                                "】\n\t\t\t\t"
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    scope.row.repType == "event" &&
                    scope.row.repEvent == "scancode_waitmsg"
                      ? _c(
                          "div",
                          [
                            _c("el-tag", { attrs: { size: "mini" } }, [
                              _vm._v("扫码结果："),
                            ]),
                            _vm._v(
                              "\n\t\t\t\t\t：【" +
                                _vm._s(scope.row.repContent) +
                                "】\n\t\t\t\t"
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    scope.row.repType == "text"
                      ? _c("div", [_vm._v(_vm._s(scope.row.repContent))])
                      : _vm._e(),
                    scope.row.repType == "image"
                      ? _c("div", [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: scope.row.repUrl,
                                target: "_blank",
                              },
                            },
                            [
                              _c("img", {
                                staticStyle: { width: "100px" },
                                attrs: { src: scope.row.repUrl },
                              }),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    scope.row.repType == "voice"
                      ? _c(
                          "div",
                          [
                            _c("WxVoicePlayer", {
                              attrs: { objData: scope.row },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    scope.row.repType == "video"
                      ? _c(
                          "div",
                          [
                            _c("WxVideoPlayer", {
                              staticStyle: { "margin-top": "40px" },
                              attrs: { objData: scope.row },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    scope.row.repType == "shortvideo"
                      ? _c(
                          "div",
                          [
                            _c("WxVideoPlayer", {
                              staticStyle: { "margin-top": "40px" },
                              attrs: { objData: scope.row },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    scope.row.repType == "link"
                      ? _c(
                          "div",
                          [
                            _c("el-tag", { attrs: { size: "mini" } }, [
                              _vm._v("链接"),
                            ]),
                            _vm._v("\n\t\t\t\t\t：\n\t\t\t\t\t"),
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: scope.row.repUrl,
                                  target: "_blank",
                                },
                              },
                              [_vm._v(_vm._s(scope.row.repName))]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                },
              },
              {
                key: "menu",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          icon: "el-icon-chat-line-round",
                          plain: "",
                          size: "small",
                          type: "text",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.wxMsgDo(scope.row, scope.index)
                          },
                        },
                      },
                      [_vm._v("\n\t\t\t\t\t消息\n\t\t\t\t")]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c(
            "el-dialog",
            {
              attrs: {
                visible: _vm.dialogMsgVisible,
                title: "用户消息",
                width: "40%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogMsgVisible = $event
                },
              },
            },
            [
              _vm.dialogMsgVisible
                ? _c("WxMsg", {
                    attrs: { appId: _vm.appId, wxUserId: _vm.wxUserId },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }